import React from 'react';
import {t} from '@lingui/core/macro';

import MainModal from 'shared/ui/Modal/MainModal';

import {ICreateGatedModalProps} from 'entities/user';

import NotifyChannelIntro from '../NotifyChannel/NotifyChannelIntro';

import AdditionalEmailForm from './AdditionalEmailForm';

const AdditionalEmailModal: React.FC<ICreateGatedModalProps> = ({open, handleClose}) => {
    // eslint-disable-next-line max-len
    const TEXT = t`на указанный email придёт письмо с подтверждением, действительное в течение 5 минут. Использовать дополнительный адрес для оповещений можно будет только после подтверждения.`;

    return (
        <MainModal
            header={t`Добавить E-mail`}
            open={open}
            handleClose={handleClose}
            size="md"
        >
            <NotifyChannelIntro text={<>{t`После нажатия`} <b>{t`«Добавить»`}</b> {TEXT}</>}/>
            <AdditionalEmailForm onSuccess={handleClose} onClose={handleClose}/>
        </MainModal>
    );
};

export default AdditionalEmailModal;
